import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './styles.css';

export default class ImageLoader extends Component {
  static propTypes = {
    width: PropTypes.string,
    ratio: PropTypes.number,
    src: PropTypes.string,
    backgroundSize: PropTypes.string,
  };
  static defaultProps = {
    width: '100%',
    ratio: 1,
    src: null,
    backgroundSize: 'cover',
  };

  constructor(props) {
    super(props);
    this.state = {
      src: null,
      opened: false,
    };
    this.loadImage = this.loadImage.bind(this);
    // this.onLoaded = this.onLoaded.bind(this);
  }

  componentWillMount() {
    if (!this.props.src) return;
    this.loadImage(this.props.src);
  }

  componentWillReceiveProps(nextProps, prevState) {
    if (!nextProps.src) return;
    if (this.props.src !== nextProps.src) {
      this.loadImage(nextProps.src);
    }
  }

  loadImage(src) {
    const image = new Image();
    this.setState({
      src: null,
      opened: false,
    });
    // image.removeEventListener('load', ()=> {
    //   onLoad();
    // })
    // image.addEventListener('load', ()=> {
    //   onLoad();
    // })
    // const onLoad = ()=> {
    //   this.setState({
    //     src: src,
    //     opened: true,
    //   });
    // }
    image.onload = () => {
      this.setState({
        src: src,
        opened: true,
      });
    };
    image.src = src;
  }

  // onLoaded() {
  // }

  render() {

    const getRatioClass = (ratio)=> {
      if (1 <= ratio) {
        return ' ratio100';
      } else if (0.9 <= ratio) {
        return ' ratio90';
      } else if (0.8 <= ratio) {
        return ' ratio80';
      } else if (0.7 <= ratio) {
        return ' ratio70';
      } else if (0.6 <= ratio) {
        return ' ratio60';
      } else if (0.5 <= ratio) {
        return ' ratio50';
      } else if (0.4 <= ratio) {
        return ' ratio40';
      } else if (0.3 <= ratio) {
        return ' ratio30';
      } else if (0.2 <= ratio) {
        return ' ratio20';
      } else {
        return ' ratio10';
      }
    };

    const getOpenedClass = (opened)=> {
      if (opened === true) {
        return ' opened';
      } else {
        return '';
      }
    };

    if (this.state.src) {
      return (
        <div className={'image-loader' + getRatioClass(this.props.ratio) + getOpenedClass(this.state.opened)} style={{width: this.props.width}}>
          <span className="image-loader__box" style={{backgroundImage: 'url(' + this.state.src + ')', backgroundSize: this.props.backgroundSize}} />
        </div>
      );
    } else {
      return (
        <div className={'image-loader' + getRatioClass(this.props.ratio) + getOpenedClass(this.state.opened)} style={{width: this.props.width}}>
          <span className="image-loader__box" />
        </div>
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/image-loader/index.jsx